<template>
  <div class="header flex flex-row">
    <div class="h-Qrcode basis-1/4" @click="showMenuHandler">
      <svg
        class="filter"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 2H5.00003C4.20438 2 3.44132 2.31607 2.87871 2.87868C2.3161 3.44129 2.00003 4.20435 2.00003 5C1.99997 5.19956 2.00001 5.79007 2.00008 6.34708C2.00017 7.08186 2.31914 7.77176 2.84003 8.29L9.00003 14.41V21C8.99969 21.1699 9.04267 21.3372 9.12491 21.4859C9.20714 21.6346 9.32592 21.7599 9.47003 21.85C9.62918 21.9486 9.81281 22.0006 10 22C10.1566 21.9991 10.3107 21.9614 10.45 21.89L14.45 19.89C14.6149 19.8069 14.7536 19.6798 14.8507 19.5227C14.9478 19.3656 14.9995 19.1847 15 19V14.41L21.12 8.29C21.6523 7.76045 22 7.06849 22 6.31767C22 5.94673 22 5.50128 22 5C22 4.20435 21.684 3.44129 21.1214 2.87868C20.5587 2.31607 19.7957 2 19 2ZM13.29 13.29C13.1974 13.3834 13.124 13.4943 13.0743 13.6161C13.0245 13.7379 12.9993 13.8684 13 14V18.38L11 19.38V14C11.0008 13.8684 10.9756 13.7379 10.9258 13.6161C10.876 13.4943 10.8027 13.3834 10.71 13.29L5.41003 8H18.59L13.29 13.29ZM20 5C20 5.55228 19.5523 6 19 6H5.00003C4.44775 6 4.00003 5.55228 4.00003 5C4.00003 4.73478 4.10539 4.48043 4.29293 4.29289C4.48046 4.10536 4.73482 4 5.00003 4H19C19.2653 4 19.5196 4.10536 19.7071 4.29289C19.8947 4.48043 20 4.73478 20 5Z"
          fill="black"
        />
      </svg>
    </div>
    <h2 class="subject basis-1/2">
      {{ title }}
    </h2>
    <div class="hmenu basis-1/4" v-if="hasVerifi">
      <img
        @click="nextHandler"
        style="filter: brightness(0.05) drop-shadow(0px 3px 0px white)"
        src="@/assets/icons/icons8-done.svg"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: String,
    hasVerifi: Boolean,
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    showMenuHandler() {
      this.$router.push({ name: "Filters" });
    },
    nextHandler() {
      this.$emit("next");
    },
  },
};
</script>

<style scoped>
.filter {
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%)
    contrast(103%);
}
</style>
